import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';

@Component({
  standalone: true,
  selector: 'replace-spinner',
  templateUrl: './replace-spinner.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    MatProgressSpinnerModule
  ],
  host: {
    class: 'contents relative'
  }
})
export class ReplaceSpinnerComponent {
  public readonly showSpinner = input.required<boolean>();

  public readonly diameter = input(16);

  public readonly spinnerClasses = input<string>('[&_circle]:stroke-primary');
}
